import React from "react";
import "./TermsConditions.css";
import { Helmet } from "react-helmet-async";

const TermsConditions = () => {
  return (
    <>
      {/* Meta Tag for No Index */}
      <Helmet>
        <meta name="robots" content="noindex" />
        <title>Terms & Conditions | 360 Bytes</title>
      </Helmet>

      <section className="terms-conditions-section">
        <div className="container">

          <div className="terms-conditions-content">

            <h1 className="terms-title">
              Terms & Conditions
            </h1>


            {/* Introduction */}
            <h2>Introduction</h2>

            <p>
              Welcome to 360 Bytes. By visiting our site, you are bound to abide by
              these Terms and Conditions. If you do not agree, please do not use
              this site.
            </p>


            {/* Our Services */}
            <h2>Our Services</h2>

            <p>
              We provide custom software designing and development services,
              including Website Design & Development, Mobile Application
              Development, Custom Software Development, E-Commerce Development,
              SaaS Development, and other digital transformation services.
            </p>

            <p>
              The scope, schedules, and deliverables of each project will be
              discussed and agreed upon before any work is initiated.
            </p>


            {/* Client Responsibilities */}
            <h2>Client Responsibilities</h2>

            <p>
              Clients are required to provide accurate and complete information,
              grant necessary access to platforms or accounts, and respond to
              feedback or approval requests promptly.
            </p>

            <p>
              All content provided, including images, logos, and text, must be
              owned by the client or legally authorized for use. Delays or failure
              in providing information may affect project timelines.
            </p>


            {/* Website Use */}
            <h2>Website Use</h2>

            <p>
              You agree to use our website in compliance with applicable laws.
              Unauthorized access, copying, modification, or destruction of site
              content is strictly prohibited.
            </p>


            {/* Ownership of Work */}
            <h2>Ownership of Work</h2>

            <p>
              All materials created by us remain our property until the completion
              of the project. Once finalized and approved, deliverables become the
              client’s property unless stated otherwise.
            </p>

            <p>
              Unless confidentiality is requested, we reserve the right to
              showcase completed projects in our portfolio.
            </p>


            {/* Confidential Information */}
            <h2>Confidential Information</h2>

            <p>
              Any personal or sensitive information shared during a project will
              be kept confidential and will not be disclosed to third parties
              without consent.
            </p>


            {/* Newsletter & Email Communications */}
            <h2>Newsletter & Email Communications</h2>

            <p>
              By opting in to receive our newsletter or marketing communications,
              you consent to receive periodic updates, news, and promotional emails
              from 360 Bytes.
            </p>

            <p>
              You may unsubscribe at any time by clicking the "Unsubscribe" link
              included at the bottom of any marketing email we send, or by contacting
              us directly at{" "}
              <a href="mailto:business@360-bytes.com">business@360-bytes.com</a> We do not sell or share your contact details with unauthorized third
              parties.
            </p>


            {/* Limitation of Responsibility */}
            <h2>Limitation of Responsibility</h2>

            <p>
              While we strive to provide high-quality services, we are not liable
              for any losses, damages, or issues arising from the use of our
              services or website.
            </p>


            {/* Changes to Terms */}
            <h2>Changes to Terms</h2>

            <p>
              We reserve the right to revise these Terms and Conditions at any
              time. Continued use of our services or website indicates acceptance
              of the updated terms.
            </p>

            <p>
              For any questions, please contact us at{" "}
              <a href="mailto:business@360-bytes.com">
                business@360-bytes.com
              </a>.
            </p>

          </div>

        </div>
      </section>
    </>
  );
};

export default TermsConditions;